import React from 'react'
import '../App.css';

import Header from '../components/Header'
import Showcase from '../components/Showcase';
import Footer from '../components/Footer';
const Projects = () => {
  return (
    <div className='App'>
        <Header />
        <Showcase />  
        <Footer />
    </div>
  )
}

export default Projects